import { render, staticRenderFns } from "./TransactionComponent.vue?vue&type=template&id=3c79c1b5"
import script from "./TransactionComponent.vue?vue&type=script&lang=js"
export * from "./TransactionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports